(function () {
  function formatMoney(cents) {
    const fmt =
      window.theme?.settings?.currencyCodeEnabled
        ? window.theme?.settings?.moneyWithCurrencyFormat
        : window.theme?.settings?.moneyFormat;
    if (window.theme?.Currency?.formatMoney) {
      return window.theme.Currency.formatMoney(cents, fmt || '');
    }
    return '£' + (parseInt(cents, 10) / 100).toFixed(2);
  }

  function getActiveSellingPlanId(scope) {
    const oneTime = scope.querySelector(
      'input[name="recurpay__group_main"][value="one-time"]:checked, ' +
      'input[name="recurpay__group_main"][value="onetime"]:checked'
    );
    if (oneTime) return null;

    const sellingPlanInput = scope.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) return sellingPlanInput.value;

    const checkedPlan = scope.querySelector('input[name="recurpay_plan_input"]:checked');
    if (checkedPlan) {
      const id = checkedPlan.getAttribute('data-selling-plan') || checkedPlan.value;
      if (id) return id;
    }
    return null;
  }

  function getSelectedDiscountPercent(scope) {
    const selectedContainer = scope.querySelector('.recurpay__widget_container--selected');
    if (selectedContainer) {
      const badge = selectedContainer.querySelector('.recurpay__discount_badge');
      if (badge) {
        const match = badge.textContent.match(/(\d+(?:\.\d+)?)\s*%/);
        if (match) {
          const pct = parseFloat(match[1]);
          if (!isNaN(pct) && pct > 0 && pct < 100) return pct;
        }
      }
    }
    const checkedPlan = scope.querySelector('input[name="recurpay_plan_input"]:checked');
    if (checkedPlan) {
      const d = parseFloat(checkedPlan.getAttribute('data-plan-discount'));
      if (!isNaN(d) && d > 0 && d < 100) return d;
    }
    return null;
  }

  function getSubscriptionPrice(priceEl, allocations) {
    const scope = priceEl.closest('body') || document;
    const variantPrice = parseInt(priceEl.dataset.variantPrice, 10);

    const sellingPlanId = getActiveSellingPlanId(scope);
    if (sellingPlanId && allocations.length) {
      const allocation = allocations.find(a => String(a.selling_plan_id) === String(sellingPlanId));
      if (allocation && parseInt(allocation.price, 10) < variantPrice) {
        return parseInt(allocation.price, 10);
      }
    }

    if (sellingPlanId) {
      const pct = getSelectedDiscountPercent(scope);
      if (pct != null) {
        const computed = Math.round(variantPrice - (variantPrice * pct / 100));
        if (computed < variantPrice) return computed;
      }
    }

    return null;
  }

  function applyToPriceEl(priceEl) {
    if (!priceEl || !priceEl.hasAttribute('data-subscription-price')) return;

    if (!priceEl.dataset.originalHtml) {
      priceEl.dataset.originalHtml = priceEl.innerHTML;
      priceEl.dataset.originalClass = priceEl.className;
    }

    let allocationsScript = priceEl.querySelector('script[data-subscription-allocations]');
    if (!allocationsScript) {
      const tmp = document.createElement('div');
      tmp.innerHTML = priceEl.dataset.originalHtml;
      allocationsScript = tmp.querySelector('script[data-subscription-allocations]');
    }

    let allocations = [];
    if (allocationsScript) {
      try { allocations = JSON.parse(allocationsScript.textContent); } catch (e) {}
    }

    const subPrice = getSubscriptionPrice(priceEl, allocations);

    if (subPrice == null) {
      if (priceEl.innerHTML !== priceEl.dataset.originalHtml) {
        priceEl.innerHTML = priceEl.dataset.originalHtml;
        priceEl.className = priceEl.dataset.originalClass;
      }
      return;
    }

    const variantPrice = parseInt(priceEl.dataset.variantPrice, 10);
    const variantCompareAt = parseInt(priceEl.dataset.variantCompareAt, 10) || 0;

    const subPriceFmt = formatMoney(subPrice);
    const variantPriceFmt = formatMoney(variantPrice);
    const compareFmt = variantCompareAt > variantPrice ? formatMoney(variantCompareAt) : null;

    priceEl.className = priceEl.dataset.originalClass + ' price--on-sale price--subscription';

    let html = '';
    html += '<span class="sr-only">Sale price</span>';
    html += '<span class="price__regular whitespace-nowrap">' + subPriceFmt + '</span>';
    html += '<span class="sr-only">Regular price</span>';
    html += '<span class="price__sale inline-flex items-center h-auto relative">' + variantPriceFmt + '</span>';
    if (compareFmt) {
      html += '<span class="price__sale inline-flex items-center h-auto relative">' + compareFmt + '</span>';
    }
    if (allocationsScript) html += allocationsScript.outerHTML;

    priceEl.innerHTML = html;
  }

  // Resolve the effective (currently-selected) price in cents for a per-can element,
  // reusing the associated price element's subscription logic when a plan is active.
  function getEffectiveVariantPriceFor(perCanEl) {
    const variantPrice = parseInt(perCanEl.dataset.variantPrice, 10);
    const container = perCanEl.parentElement;
    const priceEl = container && container.querySelector('[data-subscription-price]');
    if (priceEl) {
      let allocationsScript = priceEl.querySelector('script[data-subscription-allocations]');
      if (!allocationsScript && priceEl.dataset.originalHtml) {
        const tmp = document.createElement('div');
        tmp.innerHTML = priceEl.dataset.originalHtml;
        allocationsScript = tmp.querySelector('script[data-subscription-allocations]');
      }
      let allocations = [];
      if (allocationsScript) {
        try { allocations = JSON.parse(allocationsScript.textContent); } catch (e) {}
      }
      const sub = getSubscriptionPrice(priceEl, allocations);
      if (sub != null) return sub;
    }
    return variantPrice;
  }

  // Sticky bar: recompute "£x / can" from the effective price ÷ pack size.
  function applyPerCan() {
    document.querySelectorAll('[data-per-can]').forEach((el) => {
      const cans = parseInt(el.dataset.cans, 10);
      if (!cans || cans < 1) return;
      const effective = getEffectiveVariantPriceFor(el);
      if (!effective || isNaN(effective)) return;
      el.textContent = formatMoney(Math.round(effective / cans)) + ' / can';
    });
  }

  // Sticky bar: reflect whether one-time or subscribe is currently selected.
  function applyStickyMode() {
    const active = getActiveSellingPlanId(document);
    const label = active ? 'Subscribe & Save' : 'One-time purchase';
    document.querySelectorAll('[data-sticky-mode]').forEach((el) => {
      el.textContent = label;
    });
    // Info icon + disclaimer only make sense when a subscription is selected.
    document.querySelectorAll('[data-sticky-sub-info]').forEach((el) => {
      el.toggleAttribute('hidden', !active);
    });
  }

  // Pack selector cards: swap price + per-can between one-time and subscription,
  // using each variant's own selling-plan allocation price (pct discount as fallback).
  function applyPackCards() {
    const cards = document.querySelectorAll('.pack-card[data-pack-price]');
    if (!cards.length) return;
    const active = getActiveSellingPlanId(document);

    // Savings baseline is always the one-time smallest-pack per-can price, so when a
    // subscription is selected the pills absorb its discount too (4 Pack → Save 15%).
    let baselinePerCan = 0;
    cards.forEach((card) => {
      const base = parseInt(card.dataset.packPrice, 10);
      const cans = parseInt(card.dataset.packCans, 10);
      if (base && cans > 0) {
        const per = Math.round(base / cans);
        if (per > baselinePerCan) baselinePerCan = per;
      }
    });

    cards.forEach((card) => {
      const base = parseInt(card.dataset.packPrice, 10);
      if (!base || isNaN(base)) return;
      let price = base;
      if (active) {
        let allocations = [];
        try { allocations = JSON.parse(card.dataset.packAllocations || '[]'); } catch (e) {}
        const allocation = allocations.find(a => String(a.id) === String(active));
        if (allocation && allocation.price < base) {
          price = allocation.price;
        } else {
          const pct = getSelectedDiscountPercent(document);
          if (pct != null) price = Math.round(base - (base * pct / 100));
        }
      }
      const priceEl = card.querySelector('.pack-card__price');
      if (priceEl) priceEl.textContent = formatMoney(price);
      const cans = parseInt(card.dataset.packCans, 10);
      const perCan = cans > 0 ? Math.round(price / cans) : 0;
      const perEl = card.querySelector('.pack-card__per');
      if (perEl && perCan > 0) perEl.textContent = formatMoney(perCan) + ' / can';

      const saveEl = card.querySelector('.pack-card__save');
      if (saveEl && baselinePerCan > 0 && perCan > 0) {
        // Math.floor matches the Liquid integer division, so the server-rendered
        // one-time pills don't shift on page load.
        const pct = Math.floor(((baselinePerCan - perCan) * 100) / baselinePerCan);
        saveEl.textContent = 'Save ' + pct + '%';
        saveEl.toggleAttribute('hidden', pct <= 0);
        card.classList.toggle('pack-card--nosave', pct <= 0);
      }
    });
  }

  function applyAll() {
    document.querySelectorAll('[data-subscription-price]').forEach(applyToPriceEl);
    applyPerCan();
    applyStickyMode();
    applyPackCards();
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.name) return;
    if (t.name === 'recurpay_plan_input' ||
        t.name === 'recurpay__group_main' ||
        t.name === 'selling_plan') {
      applyAll();
    }
  }, true);

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t && t.closest && t.closest('.recurpay__widget_container, .recurpay__group_label, .recurpay_plan_option, [data-recurpay-widget], .recurpay-pdp-widget')) {
      setTimeout(applyAll, 0);
      setTimeout(applyAll, 100);
      setTimeout(applyAll, 300);
    }
  }, true);

  document.addEventListener('recurpay:init', () => {
    setTimeout(applyAll, 0);
    setTimeout(applyAll, 200);
  });
  document.addEventListener('variant:change', () => {
    setTimeout(applyAll, 0);
    setTimeout(applyAll, 150);
  });

  const observer = new MutationObserver((mutations) => {
    let needsApply = false;
    for (const m of mutations) {
      if (m.type === 'attributes') {
        const tgt = m.target;
        if (tgt?.name === 'recurpay_plan_input' ||
            tgt?.name === 'recurpay__group_main' ||
            tgt?.name === 'selling_plan' ||
            tgt?.classList?.contains?.('recurpay_selling_plan_id')) {
          needsApply = true;
          break;
        }
      }
      if (m.type === 'childList') {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.matches?.('input[name="recurpay_plan_input"], input[name="recurpay__group_main"], input[name="selling_plan"], [data-subscription-price], .recurpay-pdp-widget') ||
              n.querySelector?.('input[name="recurpay_plan_input"], input[name="recurpay__group_main"], input[name="selling_plan"], [data-subscription-price], .recurpay-pdp-widget')) {
            needsApply = true;
          }
        }
      }
    }
    if (needsApply) applyAll();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value', 'checked', 'name', 'class']
  });

  let lastSnapshot = '';
  function snapshot() {
    return Array.from(document.querySelectorAll('[data-subscription-price]'))
      .map(el => {
        const scope = el.closest('body') || document;
        const planId = getActiveSellingPlanId(scope) || 'none';
        return el.dataset.variantId + '=' + planId;
      }).join('|');
  }

  function poll() {
    const snap = snapshot();
    if (snap !== lastSnapshot) {
      lastSnapshot = snap;
      applyAll();
    }
  }

  let pollCount = 0;
  const fastPoll = setInterval(() => {
    poll();
    pollCount++;
    if (pollCount > 50) {
      clearInterval(fastPoll);
      setInterval(poll, 500);
    }
  }, 100);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  // Subscribe & save disclaimer dialog, opened from the sticky bar's info icon.
  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const opener = e.target.closest('[data-sticky-sub-info]');
    if (opener) {
      const dlg = document.getElementById(opener.getAttribute('aria-controls'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      return;
    }
    const closer = e.target.closest('[data-sticky-sub-dialog-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.sticky-sub-dialog')) {
      e.target.close(); // click on the backdrop area
    }
  });
})();
